import {User} from "./model";
import {UserState} from "./reducer";

export const moduleName = "user";

const getUserState = (state) => state[moduleName] as UserState;

const getUser = (state): User => {
    return getUserState(state);
};

const getUserTourCompleted = (_state) => {
    return true; //Disable User Tour
};

export const selectors = {
    getUser,
    getUserTourCompleted,
};